<template>
	<JqxTreeMap
		width="100%"
		:height="400"
		:renderCallbacks="renderCallbacks"
		:source="chartData"
		:hoverEnabled="true"
		@click="click($event)"
	/>
</template>

<script>
	import JqxTreeMap from 'jqwidgets-scripts/jqwidgets-vue/vue_jqxtreemap.vue';

	export default {
		name: 'WordStatsChart',
		components: { JqxTreeMap },
		props: {
			chartData: { type: Array },
		},
		data() {
			return {
				renderCallbacks: {
					'*': (elementObject, value) => {
						const element = elementObject[0];
						element.style.border = 'none';
						element.style.whiteSpace = 'nowrap';
						element.style.overflow = 'hidden';
						element.dataset.name = value.data;
						element.addEventListener('click', this.click);
						elementObject.jqxTooltip({
							content: `<div><div style="font-weight: bold; max-width: 200px; font-family: verdana; font-size: 0.9375rem;">${value.label}</div></div>`,
							position: 'mouse',
							autoHideDelay: 6000,
						});
					},
				},
			};
		},
		methods: {
			click(e) {
				const name = e.currentTarget.dataset.name;
				this.$store.commit('modal/toggleModal', {
					id: 'ReviewListByWord',
					params: name,
				});
			},
		},
	};
</script>
